module.exports = __webpack_public_path__ + "media/images/history/stodulkova2-6d64a9b7c14b15b80658e5272e3736a8.jpg";